// ======================================================================
// FILE:
// src/modules/wms/reports/components/ReportTable.jsx
//
// MODULE:
// Work Management System (WMS)
//
// FEATURE:
// Open Work Register Table
// ======================================================================

import React from "react";

export default function ReportTable({

    loading,

    rows,

    pagination,

    filters,

    setFilters,

    onSort,

    onRowClick,

}) {

    return (

        <>

            <div
                style={{

                    background: "#fff",

                    borderRadius: 14,

                    overflow: "hidden",

                    boxShadow:
                        "0 2px 8px rgba(0,0,0,0.06)",

                }}
            >

                <div
                    style={{
                        overflowX: "auto",
                    }}
                >

                    <table
                        className="table table-hover"
                        style={{
                            marginBottom: 0,
                            whiteSpace: "nowrap",
                        }}
                    >

                        <thead
    className="table-light"
    style={{
        position: "sticky",
        top: 0,
        zIndex: 10,
    }}
>

                            <tr>

                                <th
                                    style={{
                                        cursor: "pointer",
                                        userSelect: "none",
                                    }}
                                    onClick={() => onSort("work_no")}
                                >

                                    Work No

                                    {filters.sort_by === "work_no" && (

                                        filters.sort_order === "asc"

                                            ? " ▲"

                                            : " ▼"

                                    )}

                                </th>

                                <th>Title</th>

                                <th>Department</th>

                                <th>Team</th>

                                <th>Owner</th>

                                <th>Executor</th>

                                <th>Approver</th>

                                <th>Priority</th>

                                <th>Status</th>

                                <th>Start</th>

                                <th>Due</th>

                                <th>Days Left</th>

                                <th>Progress</th>

                                <th>SLA</th>

                                <th>Recurring</th>

                                <th>Comments</th>

                                <th>Attachments</th>

                                <th>Age</th>

                            </tr>

                        </thead>

                        <tbody>

                            {loading && (

                                <tr>

                                    <td
                                        colSpan="18"
                                        className="text-center py-4"
                                    >
                                        Loading...
                                    </td>

                                </tr>

                            )}

                            {!loading &&
                                rows.length === 0 && (

                                <tr>

                                    <td
                                        colSpan="18"
                                        className="text-center py-4"
                                    >
                                        No Work Found
                                    </td>

                                </tr>

                            )}

                            {!loading &&
                                rows.map((row, rowIndex) => (

                                    <tr
    key={row.work_id}

    style={{

        cursor: "pointer",

        backgroundColor:
            rowIndex % 2 === 0
                ? "#FFFFFF"
                : "#FAFAFA",

        transition: "all .15s ease",

    }}

    onMouseEnter={(e) => {

        e.currentTarget.style.background =
            "#EEF6FF";

    }}

    onMouseLeave={(e) => {

        e.currentTarget.style.background =
            rowIndex % 2 === 0
                ? "#FFFFFF"
                : "#FAFAFA";

    }}

    onClick={() =>
        onRowClick(row)
    }
>

                                        <td>{row.work_no}</td>

                                        <td>{row.title}</td>

                                        <td>{row.department_name}</td>

                                        <td>{row.team_name}</td>

                                        <td>{row.owners}</td>

                                        <td>{row.executors}</td>

                                        <td>{row.approvers}</td>

                                        <td>{row.priority}</td>

                                        <td>{row.status}</td>

                                        <td>{row.planned_start_date}</td>

                                        <td>{row.planned_due_date}</td>

                                        <td>{row.days_remaining}</td>

                                        <td>

                                            {row.checklist_progress}%

                                        </td>

                                        <td>{row.sla_status}</td>

                                        <td>

                                            {row.is_recurring
                                                ? "Yes"
                                                : "No"}

                                        </td>

                                        <td>

                                            {row.comment_count}

                                        </td>

                                        <td>

                                            {row.attachment_count}

                                        </td>

                                        <td>

                                            {row.age}

                                        </td>

                                    </tr>

                                ))}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* ========================================================= */}
            {/* PAGINATION */}
            {/* ========================================================= */}

            <div
                style={{

                    display: "flex",

                    justifyContent: "space-between",

                    alignItems: "center",

                    marginTop: 16,

                    flexWrap: "wrap",

                    gap: 12,

                }}
            >

                <div>

                    Total Records :{" "}

                    <strong>

                        {pagination.total || 0}

                    </strong>

                </div>

                <div
                    style={{

                        display: "flex",

                        alignItems: "center",

                        gap: 10,

                    }}
                >

                    <button

                        className="btn btn-outline-secondary btn-sm"

                        disabled={!pagination.has_prev}

                        onClick={() =>

                            setFilters({

                                ...filters,

                                page: pagination.page - 1,

                            })

                        }

                    >

                        Previous

                    </button>

                    <span>

                        Page{" "}

                        <strong>

                            {pagination.page || 1}

                        </strong>

                        {" "}of{" "}

                        <strong>

                            {pagination.pages || 1}

                        </strong>

                    </span>

                    <button

                        className="btn btn-outline-secondary btn-sm"

                        disabled={!pagination.has_next}

                        onClick={() =>

                            setFilters({

                                ...filters,

                                page: pagination.page + 1,

                            })

                        }

                    >

                        Next

                    </button>

                </div>

            </div>

        </>

    );

}